import React, { useState, useEffect } from "react";
import Preloader from "../src/components/Pre";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./components/Home/Home";
import Projects from "./components/Projects/Projects";
import Detect from "./components/Projects/Detect";
import Lucidity from "./components/Projects/Lucidity";
import Haunted from "./components/Projects/Haunted";
import Charm from "./components/Projects/Charm";
import Mitis from "./components/Projects/Mitis";
import About from "./components/About/About";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate
} from "react-router-dom";
import "./style.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  const [load, upadateLoad] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      upadateLoad(false);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      <Preloader load={load} />
      <div className="App" id={load ? "no-scroll" : "scroll"}>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/project" element={<Projects />} />
          <Route path="/project/detect" element={<Detect />} />
          <Route path="/project/lucidity" element={<Lucidity />} />
          <Route path="/project/hauntedlegacy" element={<Haunted />} />
          <Route path="/project/charm" element={<Charm />} />
          <Route path="/project/mitis" element={<Mitis />} />
          <Route path="/about" element={<About />} />
          <Route path="*" element={<Navigate to="/"/>} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
